import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ba8ad6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex power" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title tip-color" }, "暂无权限", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "tip-color" }, "申请权限请联系对应项目管理员", -1))

import router from '@/router';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const goApply = () => {
  router.push({ path: '/myAuth/apply' });
};

return (_ctx: any,_cache: any) => {
  const _component_e_button = _resolveComponent("e-button")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createVNode(_component_e_button, {
          style: {"margin-top":"10px"},
          onClick: goApply
        }, {
          default: _withCtx(() => [
            _createTextVNode("申请权限")
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})